module.exports = __webpack_public_path__ + "static/media/striped_bar_prewash.2d4f4ac0.svg";